import React    from 'react';
import Carousel from '../components/Carousel';
import Biography from '../components/Biography';

const Home = () => (
    <React.Fragment>
       <Carousel></Carousel>
       <Biography></Biography>
    </React.Fragment>
   
);

export default Home;